module.exports = __webpack_public_path__ + "National2Web-Medium.woff?094866e52499bd76201c6adb82e6ba9c";